const _dragOutlineColor = '#00b1ff';
const _dragOutlineLayoutColor = '#d6c1e6';

const EditorObserver = {
    _callbacks: {},

    Types: {
        EditBlockBegin: 'editBlockBegin',
        EditBlockEnd: 'editBlockEnd',
        Exit: 'exit',
        Save: 'save',
        SaveAndExit: 'saveAndExit',
        SaveIfDirty: 'saveIfDirty',
        UpdateDesignDirty: 'updateDesignDirty'
    },

    addCallback: function (name, context, callback) {
        if (!this._callbacks[context]) {
            this._callbacks[context] = {};
        }
        this._callbacks[context][name] = callback;
    },

    publish: function (name, context, options) {
        let handled = false;
        let callback;
        if (this._callbacks[context]) {
            callback = this._callbacks[context][name];
        }
        if (callback !== undefined) {
            callback(options);
            handled = true;
        } else if (options && options.completion) {
            options.completion();
            handled = true;
        }
        return handled;
    },

    removeCallback: function (name, context) {
        if (!this._callbacks[context]) {
            return;
        }
        this._callbacks[context][name] = undefined;
    }
}

const EditorStylesCommon = `
    .draggable {
        cursor: pointer;
        margin: 0;
        padding: 0;
        position: relative;
    }
    .drag-outline {
        background: transparent;
        border: 4px solid ${_dragOutlineColor};
        bottom: 0px;
        display: none;
        left: -4px;
        opacity: 0.8;
        position: absolute;
        right: -4px;
        top: -4px;
    }
    .drag-outline.drag-outline-layout {
        display: block;
    }
    .draggable.layout > .drag-outline {
        border: 4px dashed ${_dragOutlineColor};
        display: block;
    }
    .draggable.layout:hover .drag-outline-layout {
        border-color: ${_dragOutlineColor};
    }
    .draggable .builder__controls {
        display: none;
    }
    .draggable-active .tabs__controls .builder__controls,
    .draggable-active > .builder__controls {
        display: flex;
        width: 100%;
    }
    .tabs__content.builder:not(.builder-editor) .draggable-active > .builder__controls {
        display: none;
    }
    .draggable-active .builder__controls select:hover {
        cursor: pointer;
        opacity: 1;
    }
    #dropArea {
        border: 4px dashed lightgrey;
        min-height: 50px;
        position: relative;
    }
    #dropArea [draggable] {
        cursor: pointer;
        position: relative;
        z-index: 0;
    }
    #dropArea .draggable .layout-cont > [draggable] {
        z-index: 1;
    }
    #dropArea:not(.dragging) [draggable]:hover { 
        opacity: 1;
    }
    #dropArea [data-type="layout"]:hover,
    #dropArea [data-type="container"]:hover {
        opacity: 1;
    }
    #dropArea .hidden { 
        background-image: linear-gradient(to bottom, #E8E8E8, #F0F0F0);
        border: none;
        cursor: default;
        height: 10px;
        opacity: 0.2;
        position: relative;
        width: 100%;
        z-index: 1;
    }
    #dropArea .layout-horizontal .hidden-child-last {
        align-self: stretch;
        flex: 1;
        height: auto;
        width: auto;
    }
    #dropArea .layout-horizontal .hidden-child-first {
        align-self: stretch;
        height: auto;
        width: 10px;
    }
    #dropArea #bottom-hidden-enter {
        bottom: 0;
        cursor: default;
        height: 4px;
        left: 0;
        opacity: 0;
        position: absolute;
        z-index: 1;
    }
    #dropArea #bottom-hidden-exit {
        cursor: default;
        height: 30px;
        left: 0;
        opacity: 0;
        position: absolute;
        top: 100%;
        z-index: 1;
    }
    #dropArea #top-hidden-enter {
        height: 4px;
        left: 0;
        opacity: 0;
        position: absolute;
        top: 0;
        z-index: 1;
    }
    #dropArea #top-hidden-exit {
        height: 30px;
        left: 0;
        opacity: 0;
        position: absolute;
        top: -30px;
        z-index: 2;
    }
    #dropArea.dragging .drag-outline {
        border-color: ${_dragOutlineColor} !important;
        display: block !important;
        opacity: 0.3 !important;
    }
    #dropArea.dragging .drag-outline.drag-outline-layout {
        opacity: 0.6 !important;
    }
    #dropArea.dragging .layout-child .drag-outline {
        border-color: ${_dragOutlineLayoutColor} !important;
    }
    .container-disabled:after,
    .layout-disabled:after {
        background-color: #EFEFEF90;
        bottom: 0;
        content: '';
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
    }
    #blockPlaceholder {
        background-color: ${_dragOutlineColor}; 
        height: 18px; 
        min-width: 10px;
        opacity: 0.6; 
        width: 100%;
    }
    #blockPlaceholder.placeholder-nested {
        background-color: #9a37e6;
    }
    .layout-horizontal #blockPlaceholder {
        width: 30px;
    }
    .layout-child .builder-block {
        align-items: inherit;
        display: inline-flex;
        flex-direction: inherit;
        flex-wrap: wrap;
    }
    .layout-child .layout.builder-block {
        display: flex;
    }
    .layout-vertical .builder-block {
        width: 100%;
    }
    .layout-horizontal .builder-block {
        width: auto;
    }
    .layout-child .builder-block .builder-block {
        display: block;
    }
    .builder-block-unavailable {
        background-color: lightgrey;
        color: #222222;
        padding: 20px;
        text-align: center;
    }
    .builder-block-unavailable .notice {
        border-bottom: 1px solid grey;
        margin-bottom: 15px;
        padding-bottom: 15px;
    }
    .draggable.layout .drag-outline-layout-parent {
        border: 4px dashed lightgrey;
    }
    .draggable.draggable-active.layout .drag-outline-layout-parent,
    .draggable.draggable-active.layout:hover .drag-outline-layout-parent {
        border: 4px solid ${_dragOutlineColor};
    }
`;
const EditorStylesWeb = `
    ${EditorStylesCommon}
    .draggable.layout .drag-outline-layout-child {
        border-bottom: none;
        border-left: 4px dashed lightgrey;
        border-right: none;
        border-top: none;
        opacity: 0.8;
        margin-left: -2px;
        margin-right: -2px;
    }
    .draggable.layout .drag-outline-layout-child-first,
    .draggable.layout .drag-outline-layout-child-last {
        border-left-style: double;
    }
    .draggable.layout .drag-outline-layout-child-bottom,
    .draggable.layout .drag-outline-layout-child-top {
        border-bottom: 4px dashed lightgrey;
        border-left: none;
        left: 0;
        position: absolute;
        right: 0;
    }
    .draggable.layout .drag-outline-layout-child-bottom {
        bottom: 0;
    }
    .draggable.layout .drag-outline-layout-child-top {
        top: -4px;
    }
    .draggable.layout:hover .drag-outline-layout-child,
    .draggable.draggable-active.layout .drag-outline-layout-child,
    .draggable.draggable-active.layout:hover .drag-outline-layout-child {
        border-color: ${_dragOutlineColor};
    }
    .draggable-active > .drag-outline,
    .draggable:hover > .drag-outline,
    .draggable-active .layout-cont .draggable:hover .drag-outline,
    .draggable:hover .layout-cont .draggable.draggable-active .drag-outline,
    .draggable:hover .layout-cont .draggable:hover .drag-outline {
        cursor: pointer;
        display: block;
    }
    .draggable .layout-child > .draggable-active .drag-outline,
    .draggable .layout-child > .draggable:hover .drag-outline {
        border-color: ${_dragOutlineLayoutColor};
        display: block;
        right: 0;
    }
    .draggable .hover__cont .layout-child > .draggable-active .drag-outline,
    .draggable .hover__cont .layout-child > .draggable:hover .drag-outline,
    .draggable .layout-child:last-child > .draggable-active .drag-outline,
    .draggable .layout-child:last-child > .draggable:hover .drag-outline {
        right: -4px;
    }
    .draggable.draggable-active.layout .draggable > .hover__cont .layout-child .drag-outline-layout {
        border: 4px dashed ${_dragOutlineColor};
    }
    .draggable.layout:hover > .hover__cont .layout-child .drag-outline-layout {
        border: 4px dashed ${_dragOutlineColor};
    }
    .draggable.layout .draggable.layout:hover > .hover__cont .layout-child .drag-outline-layout {
        border-color: ${_dragOutlineLayoutColor};
    }
    .draggable.draggable-active.layout:hover > .hover__cont .layout-child .drag-outline-layout,
    .draggable.draggable-active.layout > .hover__cont .layout-child .drag-outline-layout {
        border: 4px solid ${_dragOutlineColor};
    }
    .draggable.draggable-active.layout .draggable.layout:hover > .hover__cont .layout-child .drag-outline-layout,
    .draggable.layout .draggable.draggable-active.layout > .hover__cont .layout-child .drag-outline-layout {
        border-color: ${_dragOutlineLayoutColor};
    }
    .draggable.layout:hover .draggable.draggable-active.layout > .hover__cont .layout-child .drag-outline-layout {
        border-style: solid;
    }
    .draggable-active .drag-outline {
        border-color: ${_dragOutlineColor};
    }
    #dropArea.dragging .draggable .builder:not(.builder-editor) .draggable .drag-outline,
    #dropArea.dragging .draggable .builder:not(.builder-editor) .draggable .drag-outline-layout-child,
    #dropArea.dragging .draggable .builder:not(.builder-editor) .hidden,
    .draggable .builder:not(.builder-editor) .draggable .drag-outline,
    .draggable .builder:not(.builder-editor) .draggable .drag-outline-layout-child,
    .foot--whitelabel.disabled .drag-outline,
    .foot--whitelabel.disabled .drag-outline-layout-child,
    .search.builder:not(.builder-editor) .draggable .drag-outline,
    .search.builder:not(.builder-editor) .draggable .drag-outline-layout-child {
        display: none !important;
    }
    .grecaptcha-badge { visibility: hidden; }
`;
const EditorStylesComposition = `
    ${EditorStylesWeb}
    .draggable .builder__controls {display:none;}
    .drag-outline, .drag-outline-layout-child {display:none!important;}
    #dropArea, #dropArea [draggable] {border:none!important;cursor:default;}
    .blank__state {background-color:#ffffff;border:1px solid lightgrey;border-radius:5px;display:flex;flex-direction:column;margin:auto;max-width:580px;padding:20px;}
    .blank__state .btn--prim {background-color:#00b1ff;border:1px solid #00b1ff;color:#ffffff;}
    .blank__state .btn--prim:hover {background-color:#ffffff;border:1px solid #00b1ff;color:#00b1ff;}
    .blank__state .btn--dark {background-color:#222222;border:1px solid #222222;color:#ffffff;}
    .blank__state .btn--dark:hover {background-color:#ffffff;border:1px solid #222222;color:#222222;}
`;
const EditorStyles = `
    ${EditorStylesCommon}
    .layout-child .builder-block {
        z-index: 1 !important;
    }
    .draggable-active,
    .draggable:hover {
        z-index: 1 !important;
    }
    .draggable.layout .drag-outline-layout-child {
        border-bottom: none;
        border-left: 4px dashed lightgrey;
        border-right: none;
        border-top: none;
        bottom: 0;
        margin-left: -2px;
        opacity: 0.8;
        position: absolute;
        top: 0;
    }
    .draggable.layout:hover .drag-outline-layout-child,
    .draggable.draggable-active.layout .drag-outline-layout-child,
    .draggable.draggable-active.layout:hover .drag-outline-layout-child {
        border-color: ${_dragOutlineColor};
    }
    .draggable.draggable-active.layout .drag-outline-layout {
        border: 4px solid ${_dragOutlineColor};
    }
    .draggable-active > .drag-outline,
    .draggable:hover > .drag-outline,
    .draggable-active .layout-cont .draggable:hover .drag-outline,
    .draggable:hover .layout-cont .draggable.draggable-active .drag-outline,
    .draggable:hover .layout-cont .draggable:hover .drag-outline {
        cursor: pointer;
        display: block;
    }
    .draggable .layout-child > .draggable-active .drag-outline,
    .draggable .layout-child > .draggable:hover .drag-outline {
        border-color: ${_dragOutlineLayoutColor};
        display: block;
        right: 0;
    }
    .draggable .layout-child:last-child > .draggable-active .drag-outline,
    .draggable .layout-child:last-child > .draggable:hover .drag-outline {
        left: -2px;
        right: -2px;
    }
    .draggable.draggable-active.layout .layout-child:first-child .drag-outline-layout,
    .draggable.draggable-active.layout:hover .layout-child:first-child .drag-outline-layout {
        border: 4px solid ${_dragOutlineColor};
        border-right: none;
    }
    .draggable.draggable-active.layout .layout-child .drag-outline-layout,
    .draggable.draggable-active.layout:hover .layout-child .drag-outline-layout {
        border: 4px solid ${_dragOutlineColor};
        border-left: 4px dashed ${_dragOutlineColor};
        border-right: none;
    }
    .draggable.draggable-active.layout .layout-child:last-child .drag-outline-layout,
    .draggable.draggable-active.layout:hover .layout-child:last-child .drag-outline-layout {
        border-right: 4px solid ${_dragOutlineColor};
    }
    // .draggable.draggable-active.layout .draggable > .hover__cont .layout-child .drag-outline-layout {
    //     border: 4px dashed ${_dragOutlineColor};
    // }
    // .draggable.layout:hover > .hover__cont .layout-child .drag-outline-layout {
    //     border: 4px dashed ${_dragOutlineColor};
    // }
    // .draggable.layout .draggable.layout:hover > .hover__cont .layout-child .drag-outline-layout {
    //     border-color: ${_dragOutlineLayoutColor};
    // }
    // .draggable.draggable-active.layout:hover > .hover__cont .layout-child .drag-outline-layout,
    // .draggable.draggable-active.layout > .hover__cont .layout-child .drag-outline-layout {
    //     border: 4px solid ${_dragOutlineColor};
    // }
    // .draggable.draggable-active.layout .draggable.layout:hover > .hover__cont .layout-child .drag-outline-layout,
    // .draggable.layout .draggable.draggable-active.layout > .hover__cont .layout-child .drag-outline-layout {
    //     border-color: ${_dragOutlineLayoutColor};
    // }
    // .draggable.layout:hover .draggable.draggable-active.layout > .hover__cont .layout-child .drag-outline-layout {
    //     border-style: solid;
    // }
    .draggable.layout:hover .layout-child .drag-outline-layout {
        border: 4px dashed ${_dragOutlineColor};
        border-right: none;
    }
    .draggable.layout:hover .layout-child:last-child .drag-outline-layout {
        border-right: 4px dashed ${_dragOutlineColor};
    }
    .draggable .layout-child .drag-outline-layout {
        border: 4px dashed lightgrey;
        border-right: none;
    }
    .draggable .layout-child:last-child .drag-outline-layout {
        border-right: 4px dashed lightgrey;
    }
    .draggable-active .drag-outline {
        border-color: ${_dragOutlineColor};
    }
`;
const EditorStylesCollateral = `
    ${EditorStyles}
    .draggable.layout .drag-outline-layout-child {
        margin-left: 0;
        margin-right: -2px;
    }
    .draggable tr .layout-header {
        border-bottom: none;
    }
    .draggable tr .layout-placeholder > div {
        border: 4px dashed transparent;
    }
    .draggable tr .layout-spacer {
        border-top: 2px dashed #efefef;
    }
    .draggable tr:first-child > .layout-spacer {
        border-top-color: lightgrey;
    }
    .draggable-active .drag-outline,
    .draggable:hover .drag-outline {
        display: block;
    }
    .draggable-active > tbody > tr > .layout-spacer,
    .draggable:hover > tbody > tr > .layout-spacer {
        border-left-color: ${_dragOutlineColor};
        border-right-color: ${_dragOutlineColor};
        border-top-color: #c7f2ff;
    }
    .draggable-active > tbody > tr:first-child > .layout-spacer,
    .draggable:hover > tbody > tr:first-child > .layout-spacer {
        border-top-color: ${_dragOutlineColor};
    }
    #dropArea.dragging .draggable.editable .draggable .drag-outline{
        display: none !important;
    }
    .draggable.editable .draggable .drag-outline,
    .draggable.editable .draggable .drag-outline-layout-child,
    .draggable.layout .layout-child .draggable.layout .layout-child .draggable .drag-outline,
    .draggable-active .layout-child .drag-outline,
    .draggable:hover .layout-child .draggable .drag-outline {
        display: none;
    }
    .draggable.editable .draggable.layout .layout-spacer {
        border-top: none;
    }
    .draggable.layout .layout-child .draggable.layout .drag-outline-layout-child {
        border-color: lightgrey;
    }
    .draggable.layout .layout-child .draggable.layout .drag-outline-layout-parent,
    .draggable.layout:hover .layout-child .draggable.layout .drag-outline-layout-parent {
        border: 4px dashed lightgrey;
        display: block;
    }
    .draggable.layout .layout-child .draggable.layout:hover .drag-outline-layout-child,
    .draggable.layout .layout-child .draggable-active.layout .drag-outline-layout-child,
    .draggable.layout .layout-child .draggable.layout:hover .drag-outline-layout-parent {
        border-color: ${_dragOutlineLayoutColor};
    }
    .draggable.layout .layout-child .draggable-active.layout:hover .drag-outline-layout-parent,
    .draggable.layout:hover .layout-child .draggable-active.layout .drag-outline-layout-parent,
    .draggable.layout .layout-child .draggable-active.layout .drag-outline-layout-parent {
        border-color: ${_dragOutlineLayoutColor};
        border-style: solid;
    }
    .draggable.layout .layout-child .draggable.layout:hover .drag-outline-layout-parent,
    .draggable.layout .layout-child .draggable-active.layout .drag-outline-layout-parent {
        right: -4px;
    }
    .draggable.layout .layout-child .draggable.layout .layout-child .draggable-active .drag-outline,
    .draggable.layout .layout-child .draggable.layout .layout-child .draggable:hover .drag-outline {
        border-color: #fed8b1;
        display: block;
    }
    .draggable.layout .layout-child .draggable.layout:hover .layout-spacer,
    .draggable.layout .layout-child .draggable-active.layout .layout-spacer {
        border-left-color: ${_dragOutlineLayoutColor};
        border-right-color: ${_dragOutlineLayoutColor};
        border-top-color: #fce7ff;
    }
    .draggable.layout .draggable.layout #blockPlaceholder.placeholder-nested {
        background-color: #fed8b1;
    }
    .draggable.layout.itemContainer .drag-outline-layout-parent {
        border: 4px solid ${_dragOutlineColor};
        display: none;
    }
    .builder__controls {
        background-color: transparent;
        cursor: move;
        font-family: 'Roboto',sans-serif;
        pointer-events: all;
        position: relative;
        text-align: center;
        white-space: nowrap;
        z-index: 1;
    }
    .builder__controls--label {
        color: #aaa;
        font-size: 11px;
        font-weight: 600;
        padding-bottom: 4px;
        letter-spacing: 0.8px;
    }
    .builder__controls--label > div {
        background-color: #ffffff;
        border-left: 1px solid lightgrey;
        border-right: 1px solid lightgrey;
        border-top: 1px solid lightgrey;
        margin-left: -4px;
        margin-right: -4px;
        padding: 3px 0 2px;
    }
    .draggable-active > tbody > .builder__controls {
        display: table-row;
    }
    .draggable-active.layout > tbody > tr > td > .drag-outline-layout-parent {
        top: 19px;
    }
    .draggable.layout .draggable-active.layout .builder__controls--label > div {
        border-left: none;
        border-right: none;
        margin-left: 0;
        margin-right: 0;
    }
    .draggable.layout .layout-child .draggable.layout .layout-child .draggable-active .layout .drag-outline,
    .draggable.layout .layout-child .draggable.layout .layout-child .draggable:hover .layout .drag-outline,
    .draggable.layout .layout-child .list-cont .draggable.layout .drag-outline-layout-parent,
    .page__header:not(.editor) .drag-outline,
    .page__header:not(.editor) .drag-outline-layout-child {
        display: none;
    }
`;

const EmailFonts = [
    { display: 'Arial', label: 'Arial', family: `arial,sans-serif`, value: `arial,sans-serif` },
    { display: 'Brush Script MT', label: 'Brush Script MT', family: `'Brush Script MT',cursive`, value: `'Brush Script MT',cursive` },
    { display: 'Courier New', label: 'Courier New', family: `'courier new',monospace`, value: `'courier new',monospace` },
    { display: 'Garamond', label: 'Garamond', family: `garamond,serif`, value: `garamond,serif` },
    { display: 'Georgia', label: 'Georgia', family: `georgia,serif`, value: `georgia,serif` },
    { default: true, display: 'Helvetica', label: 'Helvetica', family: `helvetica,sans-serif`, value: `helvetica,sans-serif` },
    { display: 'Tahoma', label: 'Tahoma', family: `tahoma,sans-serif`, value: `tahoma,sans-serif` },
    { display: 'Times New Roman', label: 'Times New Roman', family: `'Times New Roman',serif`, value: `'Times New Roman',serif` },
    { display: 'Trebuchet MS', label: 'Trebuchet MS', family: `'trebuchet ms',sans-serif`, value: `'trebuchet ms',sans-serif` },
    { display: 'Verdana', label: 'Verdana', family: `verdana,sans-serif`, value: `verdana,sans-serif` }
];

const Tool = {
    Id: {
        GlobalStylesheet: 'globalStylesheet',
        PageSettings: 'pageSettings'
    },
    defaultGlobalStylesheetConfig: () => {
        const group = 'global';
        return {
            config: {
                [group]: {
                    group,
                    label: 'Design',
                    options: [
                        {
                            group,
                            type: 'kit-container'
                        }
                    ]
                }
            }
        };
    },
    findBlockConfig: function (id, blocks, parent) {
        if (!blocks) {
            return null;
        }
        let temp;
        for (let i = 0; i < blocks.length; i++) {
            temp = blocks[i];
            if (!temp) {
                continue;
            }
            if (temp.id == id) {
                return { index: i, blocks: blocks, parent: parent };
            }
            let type = temp.type;
            if (type && type.value) {
                type = type.value;
            }
            if (temp.blocks) {
                for (let j = 0; j < temp.blocks.length; j++) {
                    // Check each block in column
                    const blockConfig = Tool.findBlockConfig(id, temp.blocks[j], temp);
                    if (!blockConfig) {
                        continue;
                    }
                    return blockConfig;
                }
            }
        }
        return null;
    },
    getDeepCopy: function (config) {
        if (typeof config !== "object" || config === null) {
            return config;
        }
        let copy = Array.isArray(config) ? [] : {}
        for (let key in config) {
            copy[key] = Tool.getDeepCopy(config[key]);
        }
        return copy;
    },
    getMap: function (config, name) {
        const map = {};
        if (config && config[name]) {
            config[name].forEach(function (d) {
                if (!d.name || d.nomap == true) {
                    return;
                }
                switch (d.type) {
                    case 'border':
                    case 'paddingMargin':
                        // Custom types that map to multiple properties
                        if (d.value) {
                            for (let id in d.value) {
                                map[id] = d.value[id];
                            }
                        }
                        return;
                }
                let _name = d.name.split('.');
                if (_name.length > 1) {
                    let _map = map;
                    for (let i = 0; i < _name.length - 1; i++) {
                        if (!_map[_name[i]]) {
                            _map[_name[i]] = {};
                        }
                        _map = _map[_name[i]];
                    }
                    _map[_name[_name.length - 1]] = d.value;
                } else {
                    map[d.name] = d.value;
                }
            });
        }
        return map;
    },
    isGlobalStylesheet: (id) => id == Tool.Id.GlobalStylesheet,
    isLayoutElement: (element) => {
        if (!element || !element.dataset) {
            return false;
        }
        return element.dataset.type == 'layout' || element.dataset.type == 'layout-horizontal' || element.dataset.type == 'layout-vertical';
    },
    isPageSettings: (id) => id == Tool.Id.PageSettings,
    validateChildContentData: (value, configBlock) => {
        if (!configBlock || !configBlock.config || !configBlock.config[value.group]) {
            // Required bits are missing
            return false;
        }
        const groupData = configBlock.config[value.group];
        if (value.index < 0 || value.index >= groupData.length) {
            // Provided index out of range
            return false;
        }
        return true;
    }

}

export { 
    EditorObserver,
    EditorStyles,
    EditorStylesCollateral,
    EditorStylesComposition,
    EditorStylesWeb,
    EmailFonts,
    Tool
};